import { Auth } from 'aws-amplify'
import { setContext } from '@apollo/client/link/context'

export const withAuth = setContext(async (_, { headers, clientAwareness = {} }) => {
	const token = (await Auth.currentSession()).getIdToken().getJwtToken()
	return {
		headers: {
			...headers,
			'apollographql-client-name': clientAwareness.name,
			'apollographql-client-version': clientAwareness.version,
			'request-time': new Date().toISOString(),
			'Authorization': token
		}
	}
})

export const getSubscriptionParams = async () => {
	return {
		authorization: (await Auth.currentSession()).getIdToken().getJwtToken()
	}
}

